import React from 'react'

function Footer() {
    return (
        <div className="bg-[#6868681a] p-6 mt-10 text-center">
            <p>Made with ❤ <span className="text-blue-500 font-semibold">Sawan Mehra</span> </p>
        </div>
    )
}

export default Footer
